const selector = ".collection-products";
let cacheManager = {};

window.addEventListener('pageshow', function(e){
  onLoad(e);
});

function onLoad(e){
  cacheManager = new PageCacheManager(
    { 
      bodySelector: selector,
      onLoaded: onLoadedCache,
      onCached: onCachedCache,
    }
  );
  
  if(!e.persisted)
  {
    document.addEventListener('click',function(e){
      const closest = e.target.closest('.product-loop .card-wrapper .card__link');
      if(closest) cacheManager.cachePage();
    });
  }
}

function infiniteScrollCollection() {
  var endlessScroll = new Ajaxinate({
    container: '.product-loop',
    pagination: '#CollectionPagination',
    method: 'scroll',
    loadingText: '',
    offset: 5000,
    callback: function(response) {
      try {
        if (productList && document.body.classList.contains('template-collection')) {
          let currentList = response.querySelectorAll('.product-grid-row');
          currentList.forEach(element => {
            if(!productList.has('element.id'))
            {
              productList.add(element.id);
            }
          })
          productList.forEach(element => {
            let items = document.querySelectorAll(`#${element}`);
            if (items.length > 1) {
              for (let i = 1; i < items.length; i++) {
                items[i].remove();
              }
            } 
          });
        }
        setTimeout(() => {    
          loadWishlist();
        }, 1000);
      }
      catch(error) {
        console.error(error);
      }
    }
  });
}

function onLoadedCache(e){
  infiniteScrollCollection();
  document.querySelector(selector).style.visibility = 'visible';
};

function onCachedCache(e){
};